import { gql } from "@apollo/client";
import {TypeDefinitionSubAttributeFields} from "./typeDefinitionSubAttribute";

export const TypeDefinitionAttributeFields = gql`
    fragment TypeDefinitionAttributeFields on TypeDefinitionAttribute {
        index
        name
        type
        inputType
        disabled
        value
        categories
        dynamicFilterListKey
        list
        hint
        dynamicFilterListKey
        dataLoaderConfig {
            dataQueryConfig {
                query
                dataKeyPath
                valueKeyPath
                titleKeyPath
                totalKeyPath
                queryVariables
            }
            valueQueryConfig {
                query
                dataKeyPath
                valueKeyPath
                titleKeyPath
            }
        }
        parentAttributeIndex
        optionValues {
            name
            value
            translatable
            dependsOnParentValues
        }
        rules {
            name
            message
            options {
                min
                max
                pattern
            }
        }
        addOnAttribute {
            index
            name
            multiple
            type
            optionValues {
                name
                value
            }
            value
        }
        inheritedValue {
            value
            displayValue
            inheritedFrom {
                id
                title
                nodeType
            }
        }
        subAttributes {
            ...TypeDefinitionSubAttributeFields
        }
    }
    ${TypeDefinitionSubAttributeFields}
`;
